import React from 'react';
import UserList  from '../components/Users_List';
//import PedidosTodosMobile  from '../components/Pedidos_Todos_Mobile';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const Users = () => {
  
  return (
    <div className="content-wrapper">
      <h3>Usuários</h3>
      <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Usuários</Breadcrumb.Item>
        </Breadcrumb>
      <Row>
        <Col
          xs={0} // Esconde em dispositivos pequenos
          sm={0} // Esconde em dispositivos médios
          md={24} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <UserList />
        </Col>
        <Col
          xs={24} // Esconde em dispositivos pequenos
          sm={24} // Esconde em dispositivos médios
          md={0} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <UserList />
        </Col>
      </Row>
    </div>
  );
};

export default Users;